import { useEffect, useState } from "react";

export const EventSlotNotCreatedList = () => {

    const [listCount, setListCount] = useState(0);

    useEffect(() => {
        getdata()
    })


    const getdata = async () => {
        let reqBody = {}
        const requestOptions = {
            method: "POST",
            headers: { "Content-type": "application/json" },
            body: JSON.stringify(reqBody),
        };
        const response = await fetch(process.env.REACT_APP_PECE_DEV_URL + "calendarapi/event-slots-not-created-count", requestOptions);
        const respdata = await response.json();
        console.log("Event Slot Not Created ", respdata);
        if (respdata && respdata.count) {
            setListCount(respdata.count)
        }
    }

    return (
        <div>Event Slot Not Created List Count : {listCount}</div>
    )
}